<template>
  <div class="card-body p-0 m-0">
    <div class="il-table">
      <div class="il-row">

        <div class="il-cell width-50">
          <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('2. Web Enquiry Reply')" :isHeader="true" />
          <titleunderline />

          <div class="dash-card-inner">
            <div class="row no-gutters">
              <div class="col-6">
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('2.2 When was your first personal contact by the dealership?')" :noLetterSpacing="true" />
                <tableitem :space="true" />
              </div>
              <div class="col-6">
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('2.3.1 If you were contacted by e-mail, did the dealer use the Lamborghini Logo in the e-mail?')" :noLetterSpacing="false" />
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('2.3.2 Did the dealer use a personalised e-mail, so that it met the following quality standards?')" :noLetterSpacing="true" />
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('2.4 The operator introduced him/herself giving name or surname?')" :noLetterSpacing="true" />
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('2.6 Please comment the enquiry reply. Was it quick and customer-friendly?')" :noLetterSpacing="true" />
              </div>
            </div>
          </div>
        </div>

        <div class="il-cell width-50">
          <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3. Web Enquiry Offer')" :isHeader="true" />
          <titleunderline />

          <div class="dash-card-inner" v-if="survey == '1090'">
            <div class="row no-gutters">
              <div class="col-6">
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3.3 Did the dealer propose an appointment to discuss the quotation/offer?')" :noLetterSpacing="true" />
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3.5 Please comment your impression on the web enquiry offer. Did everything meet your expectations?')" :noLetterSpacing="true" />
              </div>
              <div class="col-6">
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3.1 Did the dealer provide you information about the quotation?')" :noLetterSpacing="true" />
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3.1 Did the dealer provide you information about the configured car?')" :noLetterSpacing="true" />
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3.2 Did the dealer provide you information about the delivery time?')" :noLetterSpacing="true" />
              </div>
            </div>
          </div>

          <div class="dash-card-inner" v-else-if="survey == '1091'">
            <div class="row no-gutters">
              <div class="col-6">
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3.4 Did the dealer propose an appointment to book the maintenance?')" :noLetterSpacing="true" />
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3.5 Please comment your impression on the web enquiry offer. Did everything meet your expectations?')" :noLetterSpacing="true" />
              </div>
              <div class="col-6">
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3.1 Did the dealer request your VIN number?')" :noLetterSpacing="true" />
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3.2 Did the dealer ask some questions to better understand your needs/profile?')" :noLetterSpacing="true" />
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3.3 Did the dealer mention the following aspects?')" :noLetterSpacing="true" />
              </div>
            </div>
          </div>

          <div class="dash-card-inner" v-else>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import tableitem from './TableItem.vue'
  import titleunderline from './TitleUnderline'
  import KpiMixin from '@/mixins/lambo/KpiMixin';

  export default {
    components: {
      tableitem,
      titleunderline
    },

    props: {
      survey: String
    },

    mixins: [ KpiMixin ]
  }
</script>
